import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Route değiştiğinde sayfayı en üste kaydırır.
 *  Mobil menüden bir sayfaya tıklandığında footer'da kalmasını engeller.
 *  URL'de hash varsa (ör. /iletisim#form) en üste değil, o bölüme kaydırır —
 *  React Router hash'e kendiliğinden kaydırmaz. */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Hedef eleman route geçişinden hemen sonra basılıyor; bir frame bekle.
      const id = hash.slice(1);
      const scroll = () => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      };
      const t = window.setTimeout(scroll, 60);
      return () => window.clearTimeout(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
}
